import * as React from 'react';
import { clsx } from 'clsx';
import { IconActionClose12, IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import { getStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export function CloseButton(_ref) {
  var onClick = _ref.onClick,
    tabIndex = _ref.tabIndex,
    size = _ref.size,
    theme = _ref.theme,
    className = _ref.className;
  var Icon = size === 12 ? IconActionClose12 : IconActionClose16;
  var styles = getStyles(theme);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['close'], className),
    onClick: onClick,
    role: "button",
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    tabIndex: tabIndex || 0,
    children: /*#__PURE__*/_jsx(Icon, {
      color: "current_color"
    })
  });
}